import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as ProductComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import * as ANT from 'antd';
import DEFINE, { FEATURE_FLAGS, TRANSLATE_LANGUAGE } from "../../../../constants/Define";
import { FlagIcons } from '../../common/component/TranslateButton';
import { toArray } from 'lodash';
import EllipsisText from '../../common/component/EllipsisText';
let permisionActions = [];
class Products extends Component {

    state = {
        titleTable: Func.getTitleTable(Model.ProductsModel.titleTable, ['action'], ['id']),
        modelProduct: Model.ProductsModel.titleTable,
        componentTable: {
            name: {
                key: "name",
                sorter: (i, k) => i.name.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            description: {
                render: (text, record) => <EllipsisText title={this.props.t(`item.product.description`)}
                    content={text} contentMaxWidth={400}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Popover} />
            },
            translations: {
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
                render: (text, record) => <FlagIcons languages={record.translations} />,
            },
            action: {
                width: 100,
                align: 'center',
                render: (text, record) => <ProductComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteProduct={this.props.onDeleteProduct} />,
            }
        },
        products: [],
        pageSize: this.props.products.data.pageSize,
        pageIndex: this.props.products.data.pageIndex,
        totalCount: this.props.products.data.totalCount,
        totalPage: this.props.products.data.totalPage,
        isFetching: false,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PRODUCT);
        this.setState({
            pageSize: this.props.products.data.pageSize,
            pageIndex: this.props.products.data.pageIndex,
            totalCount: this.props.products.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.products.data.totalCount) / parseInt(this.props.products.data.pageSize))
        })
        this.props.onListProduct({ pageSize: this.props.products.data.pageSize, pageIndex: this.props.products.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.products.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.products.data !== prevProps.products.data) {
            this.setState({
                products: this.props.products.data.result,
                pageSize: this.props.products.data.pageSize,
                pageIndex: this.props.products.data.pageIndex,
                totalCount: this.props.products.data.totalCount,
                totalPage: this.props.products.data.totalCount / this.props.products.data.pageSize,
            })
        }
    }

    onChangeLanguage = (language) => {
        this.props.onListProduct({ pageSize: this.props.products.data.pageSize, pageIndex: this.props.products.data.pageIndex });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListProduct(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, products, modelProduct, isFetching, totalCount, pageIndex, pageSize, componentTable, } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath="products"
                        titleHeader={t('navigation.products')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Link to="/products/action"
                                    className='btn btn-primary'> + {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="product-list"
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(products, modelProduct)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'product'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, current: pageIndex, pageSize }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <Link to="/products/action"
                            //         className='btn btn-primary'> + {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                        classChildren="p-0" classParent="m-0"
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        products: state.productReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListProduct: (filters) => {
            dispatch(action.dataProductAction(filters))
        },
        onDeleteProduct: (id) => {
            dispatch(action.deleteProductAction(id))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Products));
